import { ESkuCharacteristicType } from '../models/sku-characteristic';
import type { TSkuCharacteristic } from '../models/sku-characteristic';
import { CharacteristicType } from '@/shared/apollo-api/__generated__/types';
import type { ProductPageQuery } from '@/shared/apollo-api/__generated__/types';
import type { ISkuItemCharacteristic } from './product-to-sku-list';

type TCharacteristicValues = ProductPageQuery['product']['skuList'][0]['characteristicValues'][0];

/**
 * Функция преобразует характеристики ску. Используется для маппинга характеристик к ску в ску листе
 * @param {TCharacteristicValues} characteristicValues - Характеристики выбранного продукта.
 * @return {TSkuCharacteristic[]}.
 */
export const skuCharacteristicMapper = (characteristicValues: TCharacteristicValues[]): ISkuItemCharacteristic[] => {
  return characteristicValues.map((chatacteristicsValue) => {
    switch (chatacteristicsValue.characteristic.type) {
      case CharacteristicType.Color:
        return {
          characteristicId: String(chatacteristicsValue.characteristic.id),
          type: ESkuCharacteristicType.COLOR,
          title: chatacteristicsValue.characteristic.title,
          value: {
            mainColor: chatacteristicsValue.value,
            valueId: String(chatacteristicsValue.id),
            text: chatacteristicsValue.title,
            disabled: false,
          },
        };
      case CharacteristicType.Image: {
        return {
          characteristicId: String(chatacteristicsValue.characteristic.id),
          type: ESkuCharacteristicType.IMAGE,
          title: chatacteristicsValue.characteristic.title,
          value: {
            mainColor: chatacteristicsValue.value,
            valueId: String(chatacteristicsValue.id),
            text: chatacteristicsValue.title,
            disabled: false,
            imageLink: chatacteristicsValue.photo?.link.low,
            color: chatacteristicsValue.value,
            photoKey: chatacteristicsValue.photo?.key,
          },
        };
      }
      case CharacteristicType.Text:
        return {
          characteristicId: String(chatacteristicsValue.characteristic.id),
          type: ESkuCharacteristicType.TEXT,
          title: chatacteristicsValue.characteristic.title,
          value: {
            mainColor: chatacteristicsValue.value,
            valueId: String(chatacteristicsValue.id),
            text: chatacteristicsValue.title,
            disabled: false,
          },
        };
      default:
        return undefined;
    }
  }).filter(Boolean) as ISkuItemCharacteristic[];
};
